export const COLORS = {
  PURPLE_100: '#f8f0ff',
  PURPLE_300: '#dcb9ff',
  PURPLE_200: '#ecd9ff',
  PURPLE_400: '#c894fd',
  PURPLE_500: '#ab57ff',
  PURPLE_600: '#9935ff',
  PURPLE_700: '#861dee',
  PURPLE_800: '#6e0ad1',
  PURPLE_900: '#5603a7',
  ORANGE_100: '#fff0d6',
  ORANGE_200: '#ffe2ad',
  ORANGE_300: '#ffc583',
  ORANGE_400: '#ffae65',
  ORANGE_500: '#ff8832',
  BLUE_100: '#e2f5ff',
  BLUE_200: '#b1e4ff',
  BLUE_300: '#7cd2ff',
  BLUE_400: '#34b9ff',
  BLUE_500: '#00a2fe',
  GREEN_100: '#e4fbdc',
  GREEN_200: '#d0f5c3',
  GREEN_300: '#9be282',
  GREEN_400: '#60cf37',
  GREEN_500: '#2ba600',
  GRAY_100: '#f6f6f6',
  GRAY_200: '#eeeeee',
  GRAY_300: '#cccccc',
  GRAY_400: '#999999',
  GRAY_500: '#555555',
  GRAY_600: '#4a4a4a',
  GRAY_700: '#3a3a3a',
  GRAY_800: '#2b2b2b',
  GRAY_900: '#181818',
  Light_Gray_90: '#4a494f',
  WHITE: '#ffffff',
  BLACK: '#000000',
  ERROR: '#dc3a3a',
  SURFACE: '#f6f8ff',
};
